export class GymTypeConfig {
  public allowedZones: number[];
  public allowedWorkoutTypes: number[];
}
